<template>
    <div class="notice">
        <el-tabs tab-position="left" class="notice-content">
            <el-tab-pane :label="template.title" class="immediately-notice" v-for="(template,id) in wxTemplates" :key="id">
                <recharge-msg :template="template"/>
            </el-tab-pane>
        </el-tabs>
    </div>
</template>

<script>
import {getUserSetting} from "@api/map2d";

export default {
    name:"notice-dialog",
    components:{
        // automatic_msg:()=>import("./AutomaticMsg.vue"),
        'recharge-msg':()=>import("./RechargeMsg.vue"), // 自动消息
    },
    data(){
        return {
           wxTemplates:null , // 微信模板
        }
    },
    mounted(){
       this.getTemplate();
    },
    methods:{
        // 获取模板列表
        getTemplate(){
            if(!this.wxTemplates){
                getUserSetting("wxtemplate").then(res=>{
                    if(res.status&&res.status==200){
                        let content=res.content;
                        let templates=content.templates;
                        this.wxTemplates=templates;
                    }
                });
            }
            
        },
    }
}
</script>

<style lang="scss" scoped>
.notice{
    height: 500px;
    .notice-content{
        height: 100%;
    }
}
</style>